import { _ as p } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import t from "styled-components";
import { jsx as o } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
var n = ["children"], a = /* @__PURE__ */ t.span.withConfig({
  displayName: "screenReaderOnly__HiddenText",
  componentId: "sc-7wqh97-0"
})(["position:absolute !important;width:1px;height:1px;overflow:hidden;padding:0;margin:0;clip:rect(1px 1px 1px 1px);clip:rect(1px,1px,1px,1px);white-space:nowrap;border:0;"]), v = function(e) {
  var r = e.children, i = p(e, n);
  return /* @__PURE__ */ o(a, Object.assign({
    "aria-live": "assertive"
  }, i, {
    children: r
  }));
};
export {
  v as ScreenReaderOnly
};
